const healthTourismInitState = {
    healthTourismLocation: {}
};

export default healthTourismInitState;
